import { useMutation, useQuery } from "@tanstack/react-query";
import axiosBaseURL from "..";
import { useAuth, AuthContextValue } from "../../providers/AuthProvider";


export const useCustomerList = (searchKey?: string, page: number = 0, size: number = 10) => {
  const { user } = useAuth() as AuthContextValue;

  return useQuery({
    queryKey: ["useCustomerList", searchKey, page, size], 
    staleTime: 120,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/customers/list`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
        params: {
          search: searchKey || "", 
          page,
          size,
        },
      });

      return result.data;
    },
  });
};


export const useGetCustomerById = (id?: string) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["useGetCustomerById", id],
    staleTime: 120,
    enabled: !!id,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/customers/${id}/details`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};

export const useCustomerListByOrderId = (id: string) => {
  const { authString, user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["customers by order id", id],
    staleTime: 120,
    queryFn: async () => {
      // const result = await axiosBaseURL.get(`/order/${id}/customers`, {
      //     headers: {
      //         header: `${user?.userId}/${user?.token}`,
      //     }
      // });
      const _result = {
        status: "success",
        message: "message",
        data: [
          {
            id: 1,
            fullName: "Abebe Kebede",
            tinNumber: "123456",
            phoneNumber: "2",
            birthDate: "2024-07-02",
            gender: "MALE",
            address: JSON.stringify({
              region: "Amhara",
              zone: "Semen Shewa",
              woreda: "2",
              kebele: "3",
              kebeleIdNumber: "2",
            }),
          },
          {
            id: 1,
            fullName: "Endale",
            tinNumber: "123456",
            phoneNumber: "09123456",
            birthDate: "2024-07-01",
            gender: "MALE",
            address: JSON.stringify({
              region: "Oromia",
              zone: "Misrak Shewa",
              woreda: "1",
              kebele: "1",
              kebeleIdNumber: "567",
            }),
          },
          {
            id: 1,
            fullName: "Abebe Kebede",
            tinNumber: "1234567890",
            phoneNumber: "091122334455",
            birthDate: "2024-06-28",
            gender: "MALE",
            address: JSON.stringify({
              region: "Amhara",
              zone: "Debub Wello",
              woreda: "1",
              kebele: "1",
              kebeleIdNumber: "12345",
            }),
          },
          {
            id: 1,
            fullName: "Seifu Haile",
            tinNumber: "123456789",
            phoneNumber: "0912345678",
            birthDate: "1976-06-24",
            gender: "MALE",
            address: JSON.stringify({
              region: "Amhara",
              zone: "Semen Shewa",
              woreda: "1",
              kebele: "2",
              kebeleIdNumber: "123",
            }),
          },
        ],
      };
      return _result;
    },
  });
};


export const useCustomerListByUserId = (userId: string) => {
  const { authString, user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["customers by user id", userId],
    staleTime: 120,
    queryFn: async () => {
      // const result = await axiosBaseURL.get(`/users/${userId}/customers`, {
      //     headers: {
      //         header: `${user?.userId}/${user?.token}`,
      //         Authorization: authString,
      //     }
      // });

      const _result = {
        status: "success",
        message: "message",
        data: [
          {
            id: 1,
            fullName: "Abebe Kebede",
            tinNumber: "123456",
            phoneNumber: "2",
            birthDate: "2024-07-02",
            gender: "MALE",
            address: JSON.stringify({
              region: "Amhara",
              zone: "Semen Shewa",
              woreda: "2",
              kebele: "3",
              kebeleIdNumber: "2",
            }),
          },
          {
            id: 1,
            fullName: "Endale",
            tinNumber: "123456",
            phoneNumber: "09123456",
            birthDate: "2024-07-01",
            gender: "MALE",
            address: JSON.stringify({
              region: "Oromia",
              zone: "Misrak Shewa",
              woreda: "1",
              kebele: "1",
              kebeleIdNumber: "567",
            }),
          },
          {
            id: 1,
            fullName: "Abebe Kebede",
            tinNumber: "1234567890",
            phoneNumber: "091122334455",
            birthDate: "2024-06-28",
            gender: "MALE",
            address: JSON.stringify({
              region: "Amhara",
              zone: "Debub Wello",
              woreda: "1",
              kebele: "1",
              kebeleIdNumber: "12345",
            }),
          },
          {
            id: 1,
            fullName: "Seifu Haile",
            tinNumber: "123456789",
            phoneNumber: "0912345678",
            birthDate: "1976-06-24",
            gender: "MALE",
            address: JSON.stringify({
              region: "Amhara",
              zone: "Semen Shewa",
              woreda: "1",
              kebele: "2",
              kebeleIdNumber: "123",
            }),
          },
        ],
      };
      return _result;
    },
  });
};

export const useUploadDocument = () => {
  const { user } = useAuth() as AuthContextValue;
  return useMutation({
    mutationFn: async (formData: FormData) => {
      const response = await axiosBaseURL.post("/v1/document", formData, {
        headers: {
          Token: `${user?.userId}/${user?.token}`
        },
      });
      if (!response) throw new Error("Upload failed");
      return response;
    },
  });
};